export default __webpack_public_path__ + "static/media/join-revolution.53a1ed8c.png";